<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisConfirmModal from 'dashboard/components-next/LaisConfirmModal.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();
const reason = ref('');

watch(
  () => props.show,
  value => {
    if (!value) reason.value = '';
  }
);

const confirm = () => emit('confirm', reason.value.trim());
</script>

<template>
  <LaisConfirmModal
    :show="show"
    :title="t('SALES.ARCHIVE.TITLE')"
    :description="t('SALES.ARCHIVE.DESCRIPTION')"
    :confirm-text="t('SALES.ARCHIVE.CONFIRM')"
    :cancel-text="t('SALES.ACTIONS.CLOSE')"
    icon="i-lucide-archive"
    :is-loading="isLoading"
    @close="emit('close')"
    @confirm="confirm"
  >
    <label class="mt-4 block text-sm font-semibold text-lais-text-body">
      {{ t('SALES.ARCHIVE.REASON') }}
      <textarea
        v-model="reason"
        rows="3"
        class="mt-1 w-full rounded-lais border border-lais-border px-3 py-2 text-sm"
        :placeholder="t('SALES.ARCHIVE.REASON_PLACEHOLDER')"
      />
    </label>
  </LaisConfirmModal>
</template>
